import React, { ReactElement, useEffect, useState } from 'react';

import { createUrl, request } from 'app/utils';

import { Flex, Box, Typography, Button, Section } from 'components';
import { ProductsHighlightedApiResponse, ProductsList, useProducts } from 'features/products';
import { Link, useSearchParams } from 'react-router-dom';

import { useSchool } from 'features/school';
// import { CategoryButton } from './styles';
// import { ProductsCardSkeleton } from '../productsCard';

import usestorage from 'app/utils/storage';

const ProductsHighlightedList = (): ReactElement => {
  // const [currentCategory, setCurrentCategory] = useState(0);
  const [loading, setLoading] = useState(true);
  const [fetched, setFetched] = useState(false);
  const { apiGatewayUrl, schoolUuid } = useSchool();

  const { productsHighlighted, setProductsHighlighted, clearProductsHighlighted } = useProducts();

  const storage = usestorage('localStorage');
  const currentDashboard = storage.get('currentDashboard');

  const [searchParams] = useSearchParams();
  const currentDashboardArea = searchParams.get('dashboardAreaUuid');

  const fetch = async () => {
    setLoading(true);

    await request<ProductsHighlightedApiResponse>({
      url: '/api/v1/School/HighlightedCourses',
      method: 'get',
      baseURL: apiGatewayUrl,
      params: {
        ...(currentDashboard ? { dashboardUuid: currentDashboard } : {}),
        ...(currentDashboardArea ? { dashboardAreaUuid: currentDashboardArea } : {}),
      },
    })
      .then((response) => {
        setProductsHighlighted(response.data);
      })
      .finally(() => {
        setFetched(true);
        setLoading(false);
      });
  };

  // TODO: Categorias fake
  // const categories = [
  //   ['bia-santos', 'carolina', 'cdb', 'corretora-quebrar'],
  //   ['dentro-b3', 'teco-medina', 'rf', 'corretora-quebrar'],
  //   ['bolsa', 'cdb', 'corretora-quebrar', 'dentro-b3'],
  //   ['rf', 'carolina', 'bia-santos', 'bolsa'],
  //   ['dentro-b3', 'teco-medina', 'bia-santos', 'bolsa'],
  // ];

  const isBenndorf = schoolUuid === 'cfaf550b-037d-45b2-9f84-979fb01185d4';
  // const isG10 = schoolUuid === '14d970bd-3794-4268-bf67-2c5d2d0f0285';
  const isMeuPlanoCrypto = schoolUuid === '20b929ad-c773-46e2-93de-991988587835';

  let hat = 'Nossos cursos';
  let title = 'Cursos em destaque';
  let buttonLabel = 'Todos os cursos';

  if (isBenndorf) {
    hat = 'Nossos produtos';
    title = 'Produtos em destaque';
    buttonLabel = 'Todos os produtos';
  } else if (isMeuPlanoCrypto) {
    hat = 'Conteúdos';
    title = 'Lançamentos';
    buttonLabel = 'Todos os conteúdos';
  }

  useEffect(() => {
    fetch();

    return () => {
      clearProductsHighlighted();
    };
  }, []);

  return !fetched || productsHighlighted?.length ? (
    <Section flexDirection="column" pt={{ m: 30, t: 60, d: 90 }}>
      <Flex justifyContent="space-between" flexWrap={{ m: 'wrap', d: 'nowrap' }} alignItems="flex-end">
        <Flex flexDirection="column">
          {!!hat && (
            <Typography type="type3" upper mb={1}>
              {hat}
            </Typography>
          )}

          <Typography as="h2" type="type8" fontWeight="bold">
            {title}
          </Typography>
        </Flex>

        <Box width="auto" flexGrow={0} justifyContent="flex-end">
          <Link to={createUrl('productsList')}>
            <Button mt={{ m: 20 }}>{buttonLabel}</Button>
          </Link>
        </Box>
      </Flex>

      {/* {schoolUuid === 'a9f154dd-d1f9-abcb-9f08-0242ac11cba2' ? (
        <>
          <Flex
            display={{ m: 'none', d: 'flex' }}
            flexDirection={{ m: 'column', d: 'row' }}
            justifyContent={{ d: 'space-between' }}
            mt={{ m: 4, d: 5 }}
          >
            {['Entendendo ESG', 'Comece a Investir', 'Entenda o Mercado', 'Invista Melhor', 'Finanças Pessoais'].map((label, index) => {
              return (
                <CategoryButton
                  key={`highlight-button-${index.toString()}`}
                  data-active={currentCategory === index}
                  onClick={() => setCurrentCategory(index)}
                >
                  {label}
                </CategoryButton>
              );
            })}
          </Flex>

          <ProductsList
            products={products.filter((product) => {
              return categories[currentCategory].find((slug) => slug === product.slug);
            })}
          />
        </>
      ) : ( */}

      <ProductsList loading={loading} products={productsHighlighted} />
    </Section>
  ) : (
    <></>
  );
};

export default ProductsHighlightedList;
